<template>
  <div>
    <credenciamento-execucao-vazio v-if="!temDemanda" @atualizar="buscarDemandas"/>
    <div v-else>
      <credenciamento-execucao-tabela/>
    </div>
  </div>
</template>

<script>

    import CredenciamentoExecucaoVazio
      from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/CredenciamentoExecucaoVazio.vue";
    import CredenciamentoExecucaoTabela
      from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/CredenciamentoExecucaoTabela.vue";
    import actionTypes from "@/commons/constants/action-types";
    import PaginacaoTabela from "@/commons/components/PaginacaoTabela.vue";

    export default {
      name: "CredenciamentoExecucao",
      components: {PaginacaoTabela, CredenciamentoExecucaoTabela, CredenciamentoExecucaoVazio},
      data(){
        return {
          demandas: [],
          temDemanda: false,
          credenciamentoId: null,
          totalItens: 0,
          totalPaginas: 0,
          paginacaoInterna: {
            groupBy: [],
            groupDesc: [],
            rowsPerPage: 10,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: 'id',
            sortByDefault: ['id'],
            descending: false,
            sortDescDefault: [true]
          },
        }
      },
      watch: {
        paginacaoInterna: {
          async handler() {
            await this.buscarDemandas()
          },
          deep: true,
        }
      },
      async mounted(){
        this.credenciamentoId = this.$route.params.id;
        await this.buscarDemandas()
      },
      methods: {
        async buscarDemandas(){
          const dados = {
            credenciamentoId: this.credenciamentoId,
            paginacao: this.paginacaoInterna,
          }

          const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDAS_CREDENCIAMENTO, dados)

          if (response && response.itens && response.itens.length > 0) {
            this.temDemanda = true
            this.totalItens = response.totalElements;
            this.totalPaginas = response.totalPages;
            this.demandas = response.itens;
          } else {
            this.temDemanda = false
            this.demandas = []
          }
        },
        setCredenciamentoId() {
          this.credenciamentoId = this.$route.params.id;
        },
      },
    }

</script>

<style scoped lang="stylus">

</style>